import type { InvitationStatus, RecipeBoxInvitation } from "@/lib/types";

export const normalizeInvitationStatus = (status: RecipeBoxInvitation["status"]): InvitationStatus => {
  if (!status) {
    return "pending";
  }

  const normalized = status.toLowerCase();
  if (normalized === "pending" || normalized === "accepted" || normalized === "declined" || normalized === "revoked" || normalized === "expired") {
    return normalized as InvitationStatus;
  }

  return "pending";
};

export const formatInvitationStatus = (status: InvitationStatus): string => {
  if (!status) {
    return "";
  }

  return status.charAt(0).toUpperCase() + status.slice(1);
};

